// PageInvoiceView Component

/* eslint indent: 0 */

import React from 'react'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext as dragDropContext } from 'react-dnd'
import _ from 'lodash'
import async from 'async'

import app from '../../../app.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import eventfilters from '../../../lib/eventfilters.jsx'

import BaseInvoiceView from '../../page/base_invoiceview/base_invoiceview.jsx'
import PurchaseOrderAddItem from '../../../expense/purchaseorder/purchaseorder_additem/purchaseorder_additem.jsx'
import PurchaseOrderViewIntro from '../../../expense/purchaseorder/purchaseorder_viewintro/purchaseorder_viewintro.jsx'
import InvoiceViewContent from '../../invoice/invoice_viewcontent/invoice_viewcontent.jsx'
import DialogEditInvoice from '../../../invoice/dialog/dialog_editinvoice/dialog_editinvoice.jsx'
import DialogMarkInvoice from '../../../invoice/dialog/dialog_markinvoice/dialog_markinvoice.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import DialogInvoiceFinalize from '../../../invoice/dialog/dialog_invoice_finalize/dialog_invoice_finalize.jsx'
import DialogInvoiceAddress from '../../../invoice/dialog/dialog_invoice_address/dialog_invoice_address.jsx'
import DialogFinalizeComplete from '../../../invoice/dialog/dialog_finalize_complete/dialog_finalize_complete.jsx'
import Util from '../../../lib/util.jsx'
import EmailUtil from '../../../lib/emailutil.js'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import calculate from '../../../lib/calculate.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import DialogEditInvoicePeriod from '../../../invoice/dialog/dialog_editinvoiceperiod/dialog_editinvoiceperiod.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import TermsAndConditionText from '../../../common/form/terms_and_conditions/terms_and_conditions.jsx'
import { getVatRate } from '../../../../shared/util/vat'
import DialogPdfPreview from '../../../common/dialog/dialog_pdf_preview/dialog_pdf_preview.jsx'
import { getInvoicePdfUrl, fetchTeam } from './utils'
import { PHASE_TYPES } from '../../../../shared/constants'
import { InvoicesIcon } from '../../../common/layout/menu_icons/invoices.jsx'
import { getTermsAndConditions } from '../../../lib/pdfTemplateUtils'

@dragDropContext(HTML5Backend)
class PageInvoiceView extends BaseInvoiceView {
  constructor (props) {
    super(props, 'invoice-view', 'invoices', 'invoice-view')

    this.state = {
      dataDate: null,
      profilerId: null,
      bFinalizeInprogress: false,
      forceRenderTimestamp: Date.now(),
      loading: {
        isFinalizing: false,
        isSendingEmail: false
      }
    }

    const appTeam = app.getTeam()
    this.data = {
      invoice: null,
      budget: null,
      items: [],
      projectUsers: [],
      invoicePaymentDays:
        appTeam && appTeam.profile ? appTeam.profile.payPeriod : 0,
      emailSuggestions: [],
      bSendMailWithDetails: false,
      bResendMail: false,
      taxRateVatOptions: [],
      quickbookItems: [],
      showTermsAndCondition: true,
      team: null,
      termsCleared: false
    }

    this.invoiceItem = ''
    this.pdfDownloadUrl = ''
    this.invoiceSubItem = null
    this.callbackInvoiceSubitemDelete = null
    this.showFinalize = true
    this.rerenderWhenDataIsReceived = false

    this._setFABButtonState(true, true)
    this._initRealTimeVariables()

    this._references = {
      invoiceItemAdd: React.createRef(),
      invoiceIntro: React.createRef(),
      invoiceSettingDialog: React.createRef(),
      invoiceViewContent: React.createRef(),
      refDialogEditInvoice: React.createRef(),
      refDialogInvoiceAddress: React.createRef(),
      refDialogMarkInvoice: React.createRef(),
      refdialogMail: React.createRef(),
      refDialogFinalizeComplete: React.createRef(),
      refDialogInvoiceFinalize: React.createRef(),
      dialogPeriod: React.createRef(),
      dialogPdfPreview: React.createRef()
    }
    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()
    this._profiler.setParams(props.invoiceId)

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData(false, false)
    this._initEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.invoiceId && this.props.invoiceId !== nextProps.invoiceId) {
      this._getData(false, false)
    }
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()

    this._profiler = null
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  renderContent () {
    const { handleShowFinalizeDialog, handleGoBackToPdfPreview, pdfDownloadUrl } = this
    let bDisable = false
    if (
      this.data.invoice &&
      (this.data.invoice.status !== 'Draft' || this.data.invoice.isCredit)
    ) {
      bDisable = true
    }

    const _className = `pageinnercont ${bDisable ? 'disabled' : ''}`
    const profile =
      app.getTeam() && app.getTeam().profile ? app.getTeam().profile : null
    const invoice = this.data.invoice
    const pdfDownloadDetailsUrl = getInvoicePdfUrl(invoice, true)

    return (
      <div className={_className}>
        <PurchaseOrderViewIntro
          ref={this._references.invoiceIntro}
          purchaseOrder={invoice}
          disableEdit={bDisable}
          onChange={this._onIntroChange.bind(this)}
          onDelete={this._onDeleteIntro.bind(this)}
        />
        {invoice && this.data.budget && (
          <InvoiceViewContent
            // Set a key to rerender this component to handle new data
            // since it doesn't handle changes to props properly.
            key={this.state.forceRenderTimestamp}
            ref={this._references.invoiceViewContent}
            invoice={invoice}
            isQuickbookConnected={app.isQuickbookConnected()}
            quickbookItems={this.data.quickbookItems}
            budget={InvoiceUtil.getRenderObject(
              this.data.budget,
              this.data.items
            )}
            onChange={this._onChangeBudget.bind(this)}
            onUpdateInvoiceTotal={this._onUpdateInvoiceTotal.bind(this)}
            onItemCreate={this._onItemCreate.bind(this)}
            onItemUpdate={this._onItemUpdate.bind(this)}
            hasPageBreakTop={invoice.hasPageBreakTop}
            onItemRemove={this._onClickItemRemove.bind(this)}
            onRemoveSubItem={this._onClickRemoveSubItem.bind(this)}
            disable={!(invoice.status === 'Draft')}
            projectUsers={this.data.projectUsers}
            vatRate={this._getVatRate()}
            teamCountry={profile ? profile.country : ''}
            createNewActivity={this._onCreateNewActivity.bind(this)}
            onItemExpenseCreate={this._onItemExpenseCreate.bind(this)}
            onItemExpenseUpdate={this._onItemExpenseUpdate.bind(this)}
            onItemExpenseDelete={this._onItemExpenseDelete.bind(this)}
            onUpdateInfo={this._onUpdateInvoiceInfo.bind(this)}
            onPhaseRemove={this._onPhaseRemove.bind(this)}
            projectTitle={
              invoice && invoice.project ? invoice.project.title : ''
            }
            contactName={
              invoice && invoice.contact ? invoice.contact.company : ''
            }
            onUpdateInvoiceType={this._onUpdateInvoiceType.bind(this)}
            taxRateVatOptions={this.data.taxRateVatOptions}
            onCreateTaxRate={this._onCreateTaxRate.bind(this)}
            reloadQuickbookItems={this._reloadQuickbookItems.bind(this)}
          />
        )}
        {this._renderTermsAndCondition()}
        {this._renderAddItem()}
        <DialogEditInvoice
          ref={this._references.refDialogEditInvoice}
          invoicePaymentDays={this.data.invoicePaymentDays}
          onSubmit={this._onSubmitInvoiceEdit.bind(this)}
          onDelete={this._onDeleteInvoice.bind(this)}
          showLanguage={app.teamCountry !== 'US'}
        />
        <DialogMarkInvoice
          ref={this._references.refDialogMarkInvoice}
          onSubmit={this._onSubmitMarkasPaid.bind(this)}
        />
        <DialogMail
          ref={this._references.refdialogMail}
          onSubmit={this._onSubmitMail.bind(this)}
          isLoading={this.state.loading.isSendingEmail}
          downloadUrl={pdfDownloadUrl}
          showWithoutContext
          mailSuggestions={this.data.emailSuggestions}
          showMultiAttachments
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
        />
        <DialogInvoiceFinalize
          ref={this._references.refDialogInvoiceFinalize}
          invoicePaymentDays={this.data.invoicePaymentDays}
          onSubmit={this._onSubmitFinalize.bind(this)}
          onEditAddress={this._onEditAddress.bind(this)}
          isQuickbookConnected={app.isQuickbookConnected()}
          onClickGoBack={handleGoBackToPdfPreview}
        />
        <DialogPdfPreview
          title={IntlUtil.convertMessage('invoice.view.pdfPreviewDialogTitle')}
          ref={this._references.dialogPdfPreview}
          onClickNext={handleShowFinalizeDialog}
        />
        <DialogInvoiceAddress
          ref={this._references.refDialogInvoiceAddress}
          teamCountry={app.teamCountry}
          message='invoice.form.finalizeAddrTitleInfo'
          onSubmit={this._onSubmitAddressInvoice.bind(this)}
        />
        <DialogFinalizeComplete
          ref={this._references.refDialogFinalizeComplete}
          downloadUrl={pdfDownloadUrl}
          downloadDetailsUrl={pdfDownloadDetailsUrl}
          onMail={this._onMailFinalizeInvoice.bind(this)}
        />
        <DialogEditInvoicePeriod
          ref={this._references.dialogPeriod}
          onSubmit={this._onUpdatePeriod.bind(this)}
        />
        {this._renderSettingsDialog()}
      </div>
    )
  }

  async _onAddTermsAndCondition () {
    this.data.showTermsAndCondition = true
    if (!this.data.invoice.termsAndCondition) {
      const { data } = await app.service('/api/team/pdftemplate').find({
        query: {
          teamId: app.getTeamId(),
          ident: 'invoice',
          active: true
        }
      })
      this.data.invoice.termsAndCondition =
        data && data[0] ? data[0].termsAndCondition : ''

      this.setState({ dataDate: new Date() })

      // Update terms and conditions
      if (this.data.invoice.termsAndCondition) {
        const updateObj = {
          termsAndCondition: this.data.invoice.termsAndCondition
        }

        this._onUpdateInvoiceInfo(updateObj)
      }
    }
  }

  _renderTermsAndCondition () {
    const { showTermsAndCondition, invoice } = this.data
    if (!showTermsAndCondition || !invoice) {
      return null
    }
    return (
      <TermsAndConditionText
        text={invoice.termsAndCondition}
        onChange={this.handleOnChangeTermsAndConditon}
        onBlur={this.handleOnBlurTermsAndConditon}
        onDelete={this.handleOnDeleteTermsAndCondition}
      />
    )
  }

  handleOnChangeTermsAndConditon = (value) => {
    this.data.invoice.termsAndCondition = value
    if (value === '') {
      this.data.termsCleared = true
    }
    this.setState({ dataDate: new Date() })
  };

  handleOnBlurTermsAndConditon = () => {
    const updateObj = {
      termsAndCondition: this.data.invoice.termsAndCondition
    }

    this._onUpdateInvoiceInfo(updateObj)
  };

  handleOnDeleteTermsAndCondition = () => {
    this.data.termsCleared = true
    this._onUpdateInvoiceInfo({ termsAndCondition: '' }, () => {
      this.data.invoice.termsAndCondition = ''
      this.data.showTermsAndCondition = false

      this.setState({ dataDate: new Date() })
    })
  };

  _onEditPeriod () {
    const invoice = this.data.invoice
    if (this._references.dialogPeriod.current && invoice) {
      this._references.dialogPeriod.current.show(
        invoice.periodFromDate,
        invoice.periodToDate
      )
    }
  }

  _onCopyToQuickbook () {
    app.debug('PageInvoiceView: _onCopyToQuickbook [start]')

    const copyData = {
      invoiceId: this.data.invoice.id,
      teamId: app.getTeamId(),
      clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
    }
    app
      .service('/api/quickbook/invoice')
      .create(copyData)
      .catch((err) => {
        app.debug('PageInvoiceView: _onCopyToQuickbook err', err)
      })
  }

  getContentClassname () {
    return 'alt full'
  }

  /* Event handlers */
  onAdd () {
    this.setState({ bShowClose: true })
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.show()
    }
  }

  onFABClose () {
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
    this.setState({ bShowClose: false })
  }

  _onIntroAdd (ev) {
    ev.preventDefault()

    if (this.data.invoice.introText === null) {
      this.data.invoice.introText = ''
    }

    this.setState({ bShowClose: false })
    if (this._references.invoiceIntro.current) {
      this._references.invoiceIntro.current.show(true)
    }

    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
  }

  _onDeleteIntro () {
    if (this.data.invoice !== null) {
      this.data.invoice.introText = null
      this._onIntroChange(null)
    }

    if (this._references.invoiceIntro.current) {
      this._references.invoiceIntro.current.hide()
    }
  }

  _onUpdateInvoiceType (type) {
    const updateObj = { phaseType: type }
    this._onUpdateInvoiceInfo(updateObj, null)
  }

  _onCreateTaxRate (rateObj) {
    const address = this.data.invoice.contactAddress
    if (address && address.state) {
      this.data.taxRateVatOptions.push(rateObj)
      this.setState({ dataDate: new Date() })

      app
        .service('/api/taxrate/create')
        .create({
          state: address.state,
          rate: rateObj
        })
        .catch((err) => {
          app.debug('PageInvoiceView: _onCreateTaxRate Error', err)
        })
    }
  }

  _onIntroChange (introText) {
    const updateObj = { introText: introText }
    this._onUpdateInvoiceInfo(updateObj, null)
  }

  _onUpdateInvoiceInfo (updateObj, callback) {
    if (!this.data.invoice.id) {
      return
    }

    const saveObj = _.cloneDeep(updateObj)
    if (updateObj.budget) {
      saveObj.budget = InvoiceUtil.getSaveObject(saveObj.budget).budget
    }

    if (Object.keys(saveObj).length > 0) {
      const params = {
        query: {
          $client: {
            clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
          }
        }
      }

      app
        .service('/api/invoice')
        .patch(this.data.invoice.id, saveObj, params)
        .then((_introRes) => {
          if (callback) {
            callback(null)
          }
        })
        .catch((introErr) => {
          app.debug('PageInvoiceView: _onUpdateInvoiceInfo err', introErr)
        })
    }
  }

  _onAddActivity (type, ev) {
    ev.preventDefault()
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }

    if (this._references.invoiceViewContent.current) {
      this._references.invoiceViewContent.current.onAddActivity(type)
    }
    this.setState({ bShowClose: false })
  }

  _getVatRate () {
    const invoice = this.data.invoice
    const team = app.getTeam()
    const teamCountry = team.profile.country
    const contactCountry = invoice.contactAddress
      ? invoice.contactAddress.country
      : null
    const teamVatRate = team.profile.vatRate
      ? parseFloat(team.profile.vatRate)
      : 0
    const contactVatNumber = invoice.contactVatNumber

    return getVatRate(
      teamCountry,
      contactCountry,
      teamVatRate,
      contactVatNumber
    )
  }

  _onCreateNewActivity (budget, type, phaseId, groupId) {
    const vat = this._getVatRate()
    return InvoiceUtil.createNewActivity(budget, type, phaseId, groupId, vat)
  }

  _onItemCreate (item) {
    const createObj = InvoiceUtil.getNewItemObject(item)
    delete createObj.id

    createObj.invoiceId = this.props.invoiceId

    app
      .service('/api/invoice/item')
      .create(createObj)
      .then((createItemRes) => {
        if (createItemRes) {
          item.id = createItemRes.id
        }
      })
      .catch((createItemErr) => {
        app.debug('PageInvoiceView: _onItemCreate err', createItemErr)
      })
  }

  _onItemUpdate (item, attribute, callback) {
    if (!item.id) {
      return false
    }

    const updateObj = InvoiceUtil.getUpdateItemObject(item, attribute)
    app
      .service('/api/invoice/item')
      .patch(item.id, updateObj)
      .then((_updItemRes) => {
        if (callback) {
          callback(null)
        }
      })
      .catch((updItemErr) => {
        app.debug('PageInvoiceView: _onItemUpdate err', updItemErr)
        if (callback) {
          callback(updItemErr)
        }
      })

    return ''
  }

  _onClickItemRemove (item, callback) {
    const invoice = this.data.invoice
    if (
      invoice &&
      invoice.type === 'based-on-actuals' &&
      item.id &&
      item.external
    ) {
      if (this._references.invoiceSettingDialog.current) {
        this._references.invoiceSettingDialog.current.show(
          IntlUtil.convertMessage('invoice.view.removeHoursTitle'),
          IntlUtil.convertMessage('invoice.view.removeHoursSubtitle')
        )
      }

      this.invoiceSubItem = null
      this.invoiceItem = item
    } else {
      this._onItemRemove(item, false, callback)
    }
  }

  _onClickRemoveSubItem (item, subItem, callback) {
    this.callbackInvoiceSubitemDelete = callback
    if (this._references.invoiceSettingDialog.current) {
      this._references.invoiceSettingDialog.current.show(
        IntlUtil.convertMessage('invoice.view.removeHoursTitle'),
        IntlUtil.convertMessage('invoice.view.removeHoursSubtitle')
      )
    }
    this.invoiceSubItem = subItem
    this.invoiceItem = item
  }

  _onItemRemove (item, bNeverInvoice, callback) {
    if (!item.id) {
      return false
    }

    const params = {
      query: {
        $client: { bNeverInvoice: bNeverInvoice }
      }
    }

    app
      .service('/api/invoice/item')
      .remove(item.id, params)
      .then((_remItemRes) => {
        if (this.invoiceItem && this._references.invoiceSettingDialog.current) {
          this._references.invoiceSettingDialog.current.hide()

          if (this._references.invoiceViewContent.current) {
            this._references.invoiceViewContent.current.reloadItem(
              this.invoiceItem
            )
          }

          this.invoiceItem = ''
          this.invoiceSubItem = null
          this.callbackInvoiceSubitemDelete = null
        }

        if (callback) {
          callback()
        }
      })
      .catch((remItemErr) => {
        app.debug('PageInvoiceView: _onItemRemove err', remItemErr)
        if (this._references.invoiceSettingDialog.current) {
          this._references.invoiceSettingDialog.current.hide()
        }

        this.invoiceItem = ''
        this.invoiceSubItem = null
        this.callbackInvoiceSubitemDelete = null
      })

    return ''
  }

  _onRemoveFromCurrentInvoice (ev) {
    ev.preventDefault()
    if (this.invoiceSubItem) {
      if (this.invoiceItem.expenses.length === 1) {
        this._onItemRemove(this.invoiceItem, false, () => {
          if (this._references.invoiceViewContent.current) {
            this._references.invoiceViewContent.current.recalculateInvoiceTotal()
          }
        })
      } else {
        // Recalcualte
        this._onSubItemRemove(
          this.invoiceItem,
          this.invoiceSubItem,
          false,
          () => {
            this.callbackInvoiceSubitemDelete()
            if (
              this.invoiceItem &&
              this._references.invoiceSettingDialog.current
            ) {
              this._references.invoiceSettingDialog.current.hide()
              this.invoiceItem = ''
              this.invoiceSubItem = null
              this.callbackInvoiceSubitemDelete = null
            }
          }
        )
      }
    } else {
      this._onItemRemove(this.invoiceItem, false, null)
    }
  }

  _onNeverInvoice (ev) {
    ev.preventDefault()
    if (this.invoiceSubItem) {
      if (this.invoiceItem.expenses.length === 1) {
        this._onItemRemove(this.invoiceItem, true, () => {
          if (this._references.invoiceViewContent.current) {
            this._references.invoiceViewContent.current.recalculateInvoiceTotal()
          }
        })
      } else {
        // Recalculate
        this._onSubItemRemove(
          this.invoiceItem,
          this.invoiceSubItem,
          true,
          () => {
            this.callbackInvoiceSubitemDelete()
            if (this._references.invoiceSettingDialog.current) {
              this._references.invoiceSettingDialog.current.hide()
              this.invoiceItem = ''
              this.invoiceSubItem = null
              this.callbackInvoiceSubitemDelete = null
            }
          }
        )
      }
    } else {
      this._onItemRemove(this.invoiceItem, true, null)
    }
  }

  _onSubItemRemove (invoiceItem, subItem, bNeverInvoice, callback) {
    if (!subItem.id) {
      return
    }

    const params = {
      query: {
        $client: { bNeverInvoice: bNeverInvoice }
      }
    }

    app
      .service('/api/invoice/item/expense')
      .remove(subItem.id, params)
      .then((_removeRes) => {
        if (callback) {
          callback(null)
        }
      })
      .catch((createItemErr) => {
        app.debug('PageInvoiceView: _onItemExpenseCreate err', createItemErr)
        if (this._references.invoiceSettingDialog.current) {
          this._references.invoiceSettingDialog.current.hide()
        }

        this.invoiceItem = ''
        this.invoiceSubItem = null
        this.callbackInvoiceSubitemDelete = null
      })
  }

  _onItemExpenseCreate (item, invoiceItemId) {
    const createObj = InvoiceUtil.getNewItemExpenseObject(item)
    delete createObj.id

    createObj.invoiceId = this.props.invoiceId
    createObj.invoiceItemId = invoiceItemId
    createObj.expenseDate = new Date()

    app
      .service('/api/invoice/item/expense')
      .create(createObj)
      .then((createItemRes) => {
        if (createItemRes) {
          item.id = createItemRes.id
        }
      })
      .catch((createItemErr) => {
        app.debug('PageInvoiceView: _onItemExpenseCreate err', createItemErr)
      })
  }

  _onItemExpenseUpdate (item, attribute) {
    if (!item.id) {
      return false
    }

    const updateObj = InvoiceUtil.getUpdateItemExpenseObject(item, attribute)

    app
      .service('/api/invoice/item/expense')
      .patch(item.id, updateObj)
      .then((_updItemRes) => {})
      .catch((updItemErr) => {
        app.debug('PageInvoiceView: _onItemExpenseUpdate err', updItemErr)
      })

    return ''
  }

  _onItemExpenseDelete (item) {
    if (!item.id) {
      return false
    }

    app
      .service('/api/invoice/item/expense')
      .remove(item.id)
      .then((_removeRes) => {})
      .catch((removeErr) => {
        app.debug('PageInvoiceView: _onItemExpenseDelete err', removeErr)
      })
  }

  _onPhaseRemove (phaseId, removeData, callback) {
    app
      .service('/api/common/removephase')
      .create(removeData)
      .then((_res) => {
        callback(null)
      })
      .catch((removeErr) => {
        app.debug('PageProjectViewBudget: _onPhaseRemove err', removeErr)
      })
  }

  _onUpdateInvoiceTotal (total, totalInc) {
    const updateObj = {
      total: total,
      totalInc: totalInc
    }

    app
      .service('/api/invoice')
      .patch(this.props.invoiceId, updateObj)
      .then((_updateRes) => {
        /* Always Reload if total updated */
        this._isDataLoading = false
        this._lastReloadTime = null
      })
      .catch((updateErr) => {
        app.debug('PageInvoiceView: _onUpdateInvoiceTotal err', updateErr)
      })
  }

  _onChangeBudget (budgetObj) {
    const saveObj = InvoiceUtil.getSaveObject(budgetObj)

    async.series(
      [
        (done) => {
          app
            .service('/api/invoice')
            .patch(this.props.invoiceId, { budget: saveObj.budget })
            .then((_invoiceRes) => {
              done(null)
            })
            .catch((invoiceErr) => {
              done(invoiceErr)
            })
        }
        /* (done) => {
        this._saveInvoiceItems(this.props.invoiceId, saveObj.items, done);
      } */
      ],
      (asynErr, _asyncRes) => {
        if (asynErr) {
          app.debug('PageInvoiceView: _onChangeBudget err', asynErr)
        } else {
          this._lastReloadTime === null // eslint-disable-line no-unused-expressions
        }
      }
    )
  }

  _saveInvoiceItems (invoiceId, items, callback) {
    const invoiceItemService = app.service('/api/invoice/item')

    async.map(
      items,
      (item, mapDone) => {
        const updateId = item.id

        const updateItem = _.cloneDeep(item)
        delete updateItem.id
        if (updateItem.expenses) {
          delete updateItem.expenses
        }

        if (updateId) {
          invoiceItemService
            .patch(updateId, updateItem)
            .then((_updItemRes) => {
              mapDone(null)
            })
            .catch((updItemErr) => {
              mapDone(updItemErr)
              app.debug('PageInvoiceView: _saveInvoiceItems err', updItemErr)
            })
        }
      },
      (asyncErr, _asyncRes) => {
        if (asyncErr) {
          callback(asyncErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _getData (bReload, bGetBudgetData) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0
    this._setDataLoading()

    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        invoiceId: this.props.invoiceId,
        bGetQuickbookItem: app.isQuickbookConnected(),
        bGetVatOptions: app.teamCountry === 'US',
        bGetBudgetData: bGetBudgetData || false,
        invoice: this._getInvoiceQuery()
      }
    }

    app
      .service('/api/page/invoice/view')
      .find(params)
      .then(async (result) => {
        if (result) {
          this._onPageDataRecieved(result.pageData)

          if (result.invoice) {
            this._processInvoiceDetails(result.invoice)
            if (!result.invoice.termsAndCondition && !this.data.termsCleared) {
              this.data.invoice.termsAndCondition = await getTermsAndConditions(
                app.getTeamId(),
                'invoice'
              )

              const updateObj = {
                termsAndCondition: this.data.invoice.termsAndCondition
              }

              this._onUpdateInvoiceInfo(updateObj)
            }
          }

          this.data.invoice.totalInvoiced = result.totalInvoiced || 0

          if (result.items && result.items.length > 0) {
            this.data.items = result.items || []

            if (this.data.items) {
              this.data.items.forEach((item) => {
                if (item.expenses && item.expenses.length > 0) {
                  item.expenses = _.orderBy(
                    item.expenses,
                    (expense) => new Date(expense.expenseDate),
                    'desc'
                  )
                }
              })
            }

            const vatInfo = calculate.calculateVatFromItems(this.data.items)
            this.data.invoice.vats = vatInfo.vats || []
          }

          if (result.projectUsers.length > 0) {
            this.data.projectUsers = result.projectUsers
          }

          if (result.taxRates.length > 0) {
            this.data.taxRateVatOptions = []

            const taxRate = result.taxRates[0]
            if (taxRate && taxRate.rates && taxRate.rates.length > 0) {
              taxRate.rates.forEach((rate) => {
                const vatOption = {
                  label: rate.title,
                  value: rate.percentage,
                  editable: false,
                  isService: rate.isService,
                  isProduct: rate.isProduct
                }

                this.data.taxRateVatOptions.push(vatOption)
              })
            }
          }

          this.data.quickbookItems = result.quickbookItems || []
          this._onDataReceived(null, profilerId)

          this.pdfDownloadUrl = getInvoicePdfUrl(this.data.invoice)
        }
      })
      .catch((err) => {
        this._onDataReceived(err, profilerId)
      })
  }

  _processInvoiceDetails (invoice) {
    this.data.invoice = invoice
    this.data.invoice.totalInvoiced = 0
    this.data.invoice.vats = []

    if (invoice.contact && invoice.contact.paymentDays !== -1) {
      this.data.invoicePaymentDays = invoice.contact.paymentDays
    }

    if (this.data.invoice) {
      this.data.emailSuggestions = EmailUtil.getEmailSuggestions(
        this.data.invoice.contact
      )
    }
  }

  /* _getDataBudget(callback) {
    async.series([
      (done) => {
        this._getDataInvoice(done);
      },
      (done) => {
        this._getDataInvoicedTotal(done);
      },
      (done) => {
        this._getDataInvoiceItems(done);
      }
    ], (_err, _res) => {
      callback(null);
    });
  } */

  _getInvoiceQuery () {
    return {
      $client: {
        subObjects: {
          contact: [
            'company',
            'addresses',
            'vatNo',
            'paymentDays',
            'contactPersons',
            'pdfLanguage'
          ],
          project: ['title', 'budget'],
          items: []
        }
      }
    }
  }

  _getDataInvoice (callback) {
    const params = {
      query: this._getInvoiceQuery()
    }

    app
      .service('/api/invoice')
      .get(this.props.invoiceId, params)
      .then((invoiceRes) => {
        if (invoiceRes) {
          this._processInvoiceDetails(invoiceRes)
        }

        callback(null)
      })
      .catch((invoiceErr) => {
        app.debug('PageInvoiceView: _getDataInvoice err', invoiceErr)
        callback(invoiceErr)
      })
  }

  _getContactPersonOrDefault (invoice, contactPersons) {
    let contactPersonIdent = ''
    if (invoice.contactPerson) {
      contactPersonIdent = `${invoice.contactPerson.name}${
        invoice.contactPerson.email ? ' - ' + invoice.contactPerson.email : ''
      }`
    } else if (contactPersons.length > 0) {
      contactPersonIdent = contactPersons[0].value
    }

    return contactPersonIdent
  }

  onSubmitInvoiceEdit (apiName, invoiceObj) {
    const updateObj = {
      referenceNo: invoiceObj.referenceNo ? invoiceObj.referenceNo : '',
      contactAddress: invoiceObj.contactAddress,
      contactPerson: invoiceObj.contactPerson,
      invoiceDate: invoiceObj.invoiceDate || null,
      dueDate: invoiceObj.dueDate || null,
      pdfLanguage: invoiceObj.pdfLanguage,
      termsAndCondition: invoiceObj.termsAndCondition
    }

    app
      .service(apiName)
      .patch(invoiceObj.id, updateObj)
      .then(() => {
        // Rerender when the invoice is updated since this can cause VAT to change.
        this.rerenderWhenDataIsReceived = true
      })
      .then((_editRes) => {
        if (this._references.refDialogEditInvoice.current) {
          this._references.refDialogEditInvoice.current.hide()
        }
      })
      .catch((editErr) => {
        app.debug('BaseInvoiceView: onSubmitInvoiceEdit err', editErr)
      })
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PageInvoiceView: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({ dataDate: new Date(), profilerId: profilerId })
    } else {
      app.debug('PageInvoiceView: _onDataReceived [done]')
      this.data.budget = this.data.invoice.budget
      if (!this.data.budget) {
        this.data.budget = InvoiceUtil.createEmptyBudget()
      }

      if (this.data.invoice && this.data.invoice.status === 'Draft') {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      this.showFinalize = true
      const invoice = this.data.invoice
      const contactPersonOptions = this._getContactPersonOptions(
        invoice.contact
      )

      if (invoice && invoice.contact) {
        if (
          invoice.contactAddress === undefined ||
          (invoice.contactAddress !== undefined &&
            (!invoice.contactAddress.street ||
              !invoice.contactAddress.city ||
              !invoice.contactAddress.postcode))
        ) {
          this.showFinalize = false
          const contObj = {
            contactName: invoice.contact.company,
            address: invoice.contactAddress,
            vatNo: invoice.contact.vatNo,
            contactPersonOptions: contactPersonOptions,
            contactPerson: this._getContactPersonOrDefault(
              invoice,
              contactPersonOptions
            )
          }
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.show(
              contObj,
              true
            )
          }
        }
      }

      this.setState({
        dataDate: new Date(),
        profilerId: profilerId,
        forceRenderTimestamp: this.rerenderWhenDataIsReceived
          ? Date.now()
          : this.state.forceRenderTimestamp
      })

      this.rerenderWhenDataIsReceived = false
    }
  }

  /* Private functions */
  _renderSettingsDialog () {
    return (
      <DialogSetting
        ref={this._references.invoiceSettingDialog}
        className='alt'
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onRemoveFromCurrentInvoice.bind(this)}
            >
              <Button
                icon='action-delete'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='invoice.view.removeFromCurrentInvoice' />
              </span>
            </div>
          </div>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onNeverInvoice.bind(this)}
            >
              <Button
                icon='action-delete'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='invoice.view.neverInvoice' />
              </span>
            </div>
          </div>
        </div>
      </DialogSetting>
    )
  }

  _onAddDiscountPhase () {
    const hasDiscountPhase = (this.data.budget?.phases || []).find(phase => phase.type === PHASE_TYPES.DISCOUNT)

    if (hasDiscountPhase) {
      return this._references.invoiceViewContent.current.onAddActivity('time-activity')
    }

    this._references.invoiceViewContent.current.addPhase({ type: PHASE_TYPES.DISCOUNT })
  }

  _renderAddItem () {
    if (this.data.invoice?.status !== 'Draft') {
      return null
    }

    return (
      <PurchaseOrderAddItem
        ref={this._references.invoiceItemAdd}
        onClose={() => this._onFABInvoiceViewAddClose()}
        onIntroAdd={e => this._onIntroAdd(e)}
        onAddTermsAndCondition={() => this._onAddTermsAndCondition()}
        onAddDiscountPhase={() => this._onAddDiscountPhase()}
      />
    )
  }

  _onFABInvoiceViewAddClose () {
    this._hideCloseFABButton()
  }

  _onEdit () {
    if (this.data.invoice) {
      const invoice = this.data.invoice
      const contact = invoice.contact
      const contactAddresses =
        invoice && contact && contact.addresses ? contact.addresses : null
      const contactPersonOptions = this._getContactPersonOptions(contact)

      const invoiceObj = {
        id: invoice.id,
        referenceNo: invoice.referenceNo ? invoice.referenceNo : '',
        contactName: invoice && contact ? contact.company : '',
        projectTitle: invoice && invoice.project ? invoice.project.title : '',
        addressOptions: this._getContactAddressOptions(invoice),
        addresses: contactAddresses,
        contactPersonOptions: contactPersonOptions,
        invoiceDate: invoice.invoiceDate || null,
        dueDate: invoice.dueDate || null,
        status: invoice.status || '',
        contactPerson: this._getContactPersonOrDefault(
          invoice,
          contactPersonOptions
        ),
        contactAddress:
          invoice.contactAddress && invoice.contactAddress.type
            ? invoice.contactAddress
            : contactAddresses
            ? contactAddresses[0]
            : null,
        pdfLanguage: calculate.getFileLanguage(
          invoice,
          invoice.contact,
          app.getTeam()
        ),
        termsAndCondition: invoice.termsAndCondition || ''
      }

      if (this._references.refDialogEditInvoice.current) {
        this._references.refDialogEditInvoice.current.show(invoiceObj)
      }
    }
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map((contactPerson) => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')

        contactPersonOptions.push({
          label: label,
          value: label,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _getContactAddressOptions (invoice) {
    const addressOptions = []
    const contact = invoice.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map((address) => {
        const existTypeOption = _.find(
          addressOptions,
          (addressOption) => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (invoice.contactAddress && addressOptions[0].value === undefined) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${invoice.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: invoice.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _onSubmitInvoiceEdit (invoiceObj) {
    this.onSubmitInvoiceEdit('/api/invoice', invoiceObj)
  }

  _onMarkPaid () {
    if (this.data.invoice) {
      const invoiceObj = {
        id: this.data.invoice.id,
        invoiceNo: this.data.invoice.invoiceNo,
        invoiceDate: this.data.invoice.invoiceDate,
        contactName: this.data.invoice.contact.company
      }
      if (this._references.refDialogMarkInvoice.current) {
        this._references.refDialogMarkInvoice.current.show(invoiceObj)
      }
    }
  }

  _onSubmitMarkasPaid (invoiceObj) {
    delete invoiceObj.id
    app
      .service('/api/invoice')
      .patch(this.data.invoice.id, invoiceObj)
      .then((_paidRes) => {
        this._refresh()
        if (this._references.refDialogMarkInvoice.current) {
          this._references.refDialogMarkInvoice.current.hide()
        }
      })
      .catch((paidErr) => {
        app.debug('PageInvoiceView: _onSubmitMarkasPaid err', paidErr)
      })
  }

  _onSendMail (event) {
    event.preventDefault()
    this._showEmailDialog(false, false)
  }

  _showEmailDialog (bFullDetails, bResend) {
    const params = { query: {} }
    app
      .service('/api/invoice/mail')
      .get(this.data.invoice.id, params)
      .then((result) => {
        if (result) {
          this.data.bSendMailWithDetails = bFullDetails
          this.data.bResendMail = bResend
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(result)
          }
        }
      })
      .catch((err) => {
        app.debug('PageInvoiceView: _showEmailDialog err', err)
      })
  }

  _onSubmitMail (mailObj) {
    this.toggleLoading('isSendingEmail', true)

    app.debug('PageInvoiceView: _onSubmitMail [Start]')

    EmailUtil.sendInvoiceMail(
      mailObj,
      this.data.invoice,
      this.data.bSendMailWithDetails,
      this.data.bResendMail
    )
      .then((_result) => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
        this.toggleLoading('isSendingEmail', false)
      })
      .catch((err) => {
        app.debug('PageInvoiceView: _onSubmitMail err', err)
      })
  }

  _onDeleteInvoice () {
    this.onDeleteInvoice('/api/invoice', 'invoices')
  }

  _onHeaderPdfDownload (ev) {
    ev.stopPropagation()

    if (
      this.data.invoice.type === 'based-on-actuals' &&
      !this.data.invoice.isCredit
    ) {
      ev.preventDefault()
      if (this._references.refDialogFinalizeComplete.current) {
        this._references.refDialogFinalizeComplete.current.show(
          this.data.invoice.invoiceNo,
          true,
          true,
          this.data.invoice.contact.company,
          this.data.invoice.project.title,
          false
        )
      }
    }
  }

  async _onFinalize () {
    try {
      this.toggleLoading('isFinalizing', true)
      const invoice = this.data.invoice
      const contactPersonOptions = this._getContactPersonOptions(invoice.contact)

      if (app.isQuickbookConnected()) {
        if (invoice.items) {
          const countItems = invoice.items.length
          let noItemNegative = 0
          let noItemPositive = 0

          invoice.items.map((item) => {
            if (item.total > 0) {
              noItemPositive++
            } else if (item.total < 0) {
              noItemNegative++
            }
          })

          if (noItemPositive !== countItems && noItemNegative !== countItems) {
            this.showError(
              IntlUtil.convertMessage('invoice.view.errorQuickbookCredit'),
              false,
              { timeout: 5000 }
            )
            return
          }
        } else {
          this.showError(
            IntlUtil.convertMessage('invoice.view.errorQuickbookCredit'),
            false,
            { timeout: 5000 }
          )
          return
        }
      }

      // Show address dialog if it is incomplete
      if (
        invoice.contactAddress === undefined ||
        (invoice.contactAddress !== undefined &&
          (!invoice.contactAddress.street ||
            !invoice.contactAddress.city ||
            !invoice.contactAddress.postcode))
      ) {
        this.showFinalize = true
        const contObj = {
          contactName: invoice.contact.company,
          address: invoice.contactAddress,
          vatNo: invoice.contact.vatNo,
          contactPersonOptions: contactPersonOptions,
          contactPerson: this._getContactPersonOrDefault(
            invoice,
            contactPersonOptions
          )
        }
        if (this._references.refDialogInvoiceAddress.current) {
          this._references.refDialogInvoiceAddress.current.show(contObj, true)
        }
      } else {
        // Fetch team information, necessary for the "finalize invoice" modal
        this.team = await fetchTeam(app.loggedInUserTeam.teamId)
        this._references.dialogPdfPreview.current.show(this.pdfDownloadUrl)
      }
    } finally {
      this.toggleLoading('isFinalizing', false)
    }
  }

  handleGoBackToPdfPreview = () => {
    this._references.refDialogInvoiceFinalize.current.hide()
    this._references.dialogPdfPreview.current.show(this.pdfDownloadUrl)
  }

  handleShowFinalizeDialog = () => {
    const { invoice } = this.data
    const contactPersonOptions = this._getContactPersonOptions(invoice.contact)
    const invoiceDate = invoice.invoiceDate
      ? this._getInvoiceDateForFinalize(invoice.invoiceDate)
      : new Date()

    const dueDate = DateUtil.addDaysToDate(
      invoiceDate,
      this.data.invoicePaymentDays
    )

    const invFinalObj = {
      invoiceDate,
      dueDate,
      total: invoice.total,
      totalInc: invoice.totalInc,
      contactName: invoice.contact.company,
      addressOptions: this._getContactAddressOptions(invoice),
      addresses:
        invoice && invoice.contact && invoice.contact.addresses
          ? invoice.contact.addresses
          : null,
      contactPersonOptions: contactPersonOptions,
      contactPerson: this._getContactPersonOrDefault(
        invoice,
        contactPersonOptions
      ),
      contactAddress: invoice.contactAddress ? invoice.contactAddress : '',
      vatLength: invoice.vats ? invoice.vats.length : 0
    }

    const promptForInitialInvoiceNumber =
      this.team && !this.team.initialInvoiceNumber

    this._references.dialogPdfPreview.current.hide()
    this._references.refDialogInvoiceFinalize.current.show(
      invFinalObj,
      promptForInitialInvoiceNumber
    )
  };

  _getInvoiceDateForFinalize (invoiceDate) {
    const invoiceDateTimeStamp = new Date(invoiceDate).getTime()
    const currentDateTimeStamp = new Date().getTime()

    if (currentDateTimeStamp < invoiceDateTimeStamp) {
      return invoiceDate
    }

    if (Util.isDateEqual(new Date(), new Date(invoiceDate))) {
      return invoiceDate
    }

    return new Date()
  }

  _onClickInvoice (pageIdent, param, ev) {
    ev.preventDefault()
    app.changePage(pageIdent, param)
  }

  _onSubmitFinalize (invoiceObj, onFinish = () => {}) {
    const teamUpdatePromise =
      invoiceObj && invoiceObj.initialInvoiceNumber
        ? app.service('/api/team').patch(app.getTeamId(), {
            initialInvoiceNumber: invoiceObj.initialInvoiceNumber
          })
        : Promise.resolve(null)

    // The invoice we get from the Finalize dialog contains a key for initialInvoiceNumber
    // even if it doesn't contain a value. However, that key isn't in the scheme for
    // /api/invoice.patch - and it doesn't need to be. So, we copy the invoice, and
    // remove the initialInvoiceNumber - we don't need it any more.
    var pureInvoice = Object.assign({}, invoiceObj)
    delete pureInvoice.initialInvoiceNumber

    teamUpdatePromise.then(() => {
      const params = {
        query: {
          $client: {
            clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
          }
        }
      }
      this.setState({ bFinalizeInprogress: true, dataDate: new Date() })
      app.service('/api/invoice').timeout = 30000
      app
        .service('/api/invoice')
        .patch(this.data.invoice.id, pureInvoice, params)
        .then((finRes) => {
          if (this._references.refDialogInvoiceFinalize.current) {
            this._references.refDialogInvoiceFinalize.current.hide()
          }

          if (
            app.teamCountry !== 'US' ||
            (!app.isQuickbookConnected() &&
              this._references.refDialogFinalizeComplete.current)
          ) {
            this._references.refDialogFinalizeComplete.current.show(
              finRes && finRes.invoiceNo ? finRes.invoiceNo : '',
              !!(finRes.type === 'based-on-actuals' && !finRes.isCredit),
              false,
              this.data.invoice.contact.company,
              this.data.invoice.project.title,
              false
            )
          }
          if (onFinish) onFinish()
        })
        .catch((finErr) => {
          if (onFinish) onFinish()
          app.debug('PageInvoiceView: _onSubmitFinalize err', finErr)
        })
    })
  }

  _onEditAddress (e) {
    e.preventDefault()
    const invoice = this.data.invoice
    const contactPersonOptions = this._getContactPersonOptions(invoice.contact)

    if (invoice) {
      const contObj = {
        contactName: invoice.contact.company,
        address: invoice.contact.address,
        vatNo: invoice.contact.vatNo,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          invoice,
          contactPersonOptions
        )
      }
      if (this._references.refDialogInvoiceAddress.current) {
        this._references.refDialogInvoiceAddress.current.show(contObj, true)
      }
    }
  }

  _onSubmitAddressInvoice (updateObj) {
    const invoice = this.data.invoice
    const contactAddresses = []
    let bUpdateExistingCont = false

    if (invoice.contactAddress !== undefined) {
      invoice.contact.addresses.map((address) => {
        if (address.type === invoice.contactAddress.type) {
          bUpdateExistingCont = true
          address.street = updateObj.address.street
            ? updateObj.address.street
            : address.street
          address.postcode = updateObj.address.postcode
            ? updateObj.address.postcode
            : address.postcode
          address.city = updateObj.address.city
            ? updateObj.address.city
            : address.city
          address.state = updateObj.address.state
            ? updateObj.address.state
            : address.state
          address.country = updateObj.address.country
            ? updateObj.address.country
            : address.country
          address.type = address.type ? address.type : 'Invoice'
        }
        contactAddresses.push(address)
      })
    }

    const address = {
      street: updateObj.address.street,
      postcode: updateObj.address.postcode,
      city: updateObj.address.city,
      state: updateObj.address.state,
      country: updateObj.address.country,
      type: updateObj.address.type ? updateObj.address.type : 'Invoice',
      streetNumber: updateObj.address.streetNumber
    }

    const contObj = {
      company: updateObj.company,
      addresses:
        bUpdateExistingCont && contactAddresses && contactAddresses.length > 0
          ? contactAddresses
          : [address],
      vatNo: updateObj.vatNo
    }

    if (updateObj.contactPersons && updateObj.contactPersons.length > 0) {
      contObj.contactPersons = updateObj.contactPersons
    }

    async.series(
      [
        (done) => {
          this._updateContactAddresses(contObj, done)
        },
        (done) => {
          this._updateInvoiceContact('/api/invoice', updateObj, done)
        }
      ],
      (err, _res) => {
        if (err) {
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.showError()
          }
          app.debug('PageInvoiceView: _onSubmitAddressInvoice err', err)
        } else {
          if (this.showFinalize) {
            if (this._references.refDialogInvoiceFinalize.current) {
              this._references.refDialogInvoiceFinalize.current.hide()
            }

            this._getDataInvoice((_res) => {
              this._onFinalize()
            })
          }
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.hide()
          }
        }
      }
    )
  }

  _updateContactAddresses (contactObj, callback) {
    app
      .service('/api/contact')
      .patch(this.data.invoice.contactId, contactObj)
      .then((_contRes) => {
        callback(null)
      })
      .catch((contUpdateErr) => {
        app.debug(
          'PageInvoiceView: _updateContactAddresses err',
          contUpdateErr
        )
        callback(contUpdateErr)
      })
  }

  _onMailFinalizeInvoice (bFullDetails) {
    if (this._references.refDialogInvoiceFinalize.current) {
      this._references.refDialogInvoiceFinalize.current.hide()
    }
    if (this._references.refDialogFinalizeComplete.current) {
      this._references.refDialogFinalizeComplete.current.hide()
    }
    this._showEmailDialog(bFullDetails, false)
  }

  _onUpdatePeriod (fromDate, toDate) {
    if (this._references.dialogPeriod.current) {
      this._references.dialogPeriod.current.hide()
    }

    if (!this.data.invoice || !this.data.invoice.id) return

    const updateData = {
      periodFromDate: fromDate,
      periodToDate: toDate
    }

    return app
      .service('/api/invoice')
      .patch(this.data.invoice.id, updateData)
      .then(() => {})
      .catch((err) => {
        app.debug('Error in _onUpdatePeriod ', err)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.invoicePatched = this._eventReload.bind(
      this,
      'Invoice',
      'Patched'
    )
    this._eventHandlers.quickbookInvoiceCreated = this._eventQuickbookReload.bind(
      this,
      'Copy Quickbook invoice',
      'Created'
    )

    const invoiceService = app.service('/api/invoice')
    invoiceService.on('patched', this._eventHandlers.invoicePatched)

    const quickbookInvoiceService = app.service('/api/quickbook/invoice')
    quickbookInvoiceService.on(
      'created',
      this._eventHandlers.quickbookInvoiceCreated
    )
  }

  _eventReload (objectName, eventName, eventData) {
    if (this._canRealTimeReload() && eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageInvoiceView - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _eventQuickbookReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      if (eventData.id === this.props.invoiceId) {
        if (eventData.quickbook && eventData.quickbook.id) {
          this.showSuccess('invoice.view.copyToQuickbookSuccess')
        } else if (eventData.quickbook && eventData.quickbook.message) {
          if (
            eventData.quickbook.message ===
            'Invoice contains both positive and negative values'
          ) {
            this.showError(
              IntlUtil.convertMessage('invoice.view.errorQuickbookCredit'),
              false,
              { timeout: 10000 }
            )
          } else {
            this.showError(eventData.quickbook.message, false, {
              timeout: 10000
            })
          }
        } else {
          this.showError('invoice.view.copyToQuickbookError')
        }

        this.setState({ bFinalizeInprogress: false, dataDate: new Date() })
      }
    }
  }

  _releaseEvents () {
    const invoiceService = app.service('/api/invoice')
    invoiceService.off('patched', this._eventHandlers.invoicePatched)

    this._eventHandlers.invoicePatched = null
  }

  /* Render Header Functions START */

  renderHeader () {
    const { invoice, invoicePaymentDays } = this.data
    const { loading: { isFinalizing } } = this.state
    const isQuickbookConnected = app.isQuickbookConnected()

    if (!invoice) {
      return null
    }

    /*
      Stat infos should be show based on invoice status
      1. Draft: Project, Invoiced, PaymentDays, isRecurring => InvoicePeriod
      2. Final: Project, Invoiced, invoiceNumber, !isQuickbookConnected => invoiceDate, paymentDueDate
      3. Overdue: Project, Invoiced, invoiceNumber, !isQuickbookConnected => invoiceDate, paymentDueDate
      4. Paid: Project, Invoiced, invoiceNumber, !isQuickbookConnected => invoiceDate, paidDate
    */

    const useProjectNumber = app.projectSetting.useProjectNo
    const projectNumber = invoice.project.projectNumber

    const statInfos = [
      useProjectNumber &&
        projectNumber && {
          title: 'invoice.view.labelProjectNumber',
          value: `${projectNumber}`,
          onClick: this._onHeaderOpenProject.bind(this, invoice.projectId)
        },
      {
        title: 'invoice.view.labelProject',
        value: invoice.project ? invoice.project.title : '',
        onClick: this._onHeaderOpenProject.bind(this, invoice.projectId)
      },
      {
        title: 'invoice.view.labelInvoiced',
        value: invoice.totalInvoiced,
        isPrice: true
      }
    ].filter(Boolean)

    // If quickbook connected, Paid and Overdue options should be hidden, invoice should act like Final
    let invoiceStatus = invoice.status
    if (
      isQuickbookConnected &&
      (invoiceStatus === 'Paid' || invoiceStatus === 'Overdue')
    ) {
      invoiceStatus = 'Final'
    }

    if (invoiceStatus === 'Draft') {
      statInfos.push({
        title: 'invoice.view.labelPaymentPeriod',
        value: `${invoicePaymentDays} ${IntlUtil.convertMessage(
          'invoice.view.days'
        )}`
      })
    } else {
      statInfos.push(
        {
          title: 'invoice.view.labelInvoiceNumber',
          value: invoice.invoiceNo
        },
        {
          title: 'invoice.view.labelInvoiceDate',
          value: DateUtil.getDisplayDate(invoice.invoiceDate)
        }
      )

      if (invoiceStatus === 'Final' || invoiceStatus === 'Overdue') {
        if (!isQuickbookConnected) {
          statInfos.push({
            title: 'invoice.view.labelPaymentDue',
            value: DateUtil.getDisplayDate(invoice.dueDate)
          })
        }
      } else if (invoiceStatus === 'Paid') {
        statInfos.push({
          title: 'invoice.view.labelPaidDate',
          value: DateUtil.getDisplayDate(invoice.paymentDate)
        })
      }
    }

    if (invoice.isRecurring) {
      statInfos.push({
        title: 'invoice.view.labelInvoicePeriod',
        value: `${DateUtil.getDisplayDate(
          invoice.periodFromDate
        )} / ${DateUtil.getDisplayDate(invoice.periodToDate)}`
      })
    }

    if (invoice.isCredit) {
      statInfos.push({
        title: 'invoice.view.labelOriginalInvoice',
        value: invoice.parentNo,
        onClick: this._onHeaderOpenParentInvoice.bind(this, invoice.parentId)
      })
    }

    if (invoice.showAdditionalInfo) {
      statInfos.push({
        title: 'invoice.view.labelAdditionalInfo',
        value: IntlUtil.convertMessage('invoice.view.vatReverseCharged')
      })
    }

    /*
      Action infos should be show based on invoice status
      1. Draft: Edit, (isRecurring => EditPeriod), Finalize, (!isQuickbookConnected => Mail, Download)
      2. Final: (!isQuickbookConnected => Mail, Download, MakePaid)
      3. Overdue: (!isQuickbookConnected => Mail, Download, MakePaid)
      4. Paid: (!isQuickbookConnected => Mail, Download)
    */

    const actions = []
    const rightActions = []
    this.pdfDownloadUrl = getInvoicePdfUrl(invoice)

    if (!isQuickbookConnected) {
      const downloadUrl = invoice.type !== 'based-on-actuals' || invoice.isCredit ? this.pdfDownloadUrl : null

      actions.push(
        {
          ident: 'mail',
          icon: 'mail',
          tooltip: 'invoice.view.tipMail',
          tooltipPosition: 'top',
          onClick: this._onSendMail.bind(this)
        },
        {
          ident: 'download',
          icon: 'download-solid',
          tooltip: 'invoice.view.tipDownload',
          tooltipPosition: 'top',
          href: downloadUrl,
          target: '_blank',
          onClick: this._onHeaderPdfDownload.bind(this)
        }
      )

      if (invoiceStatus === 'Final' || invoiceStatus === 'Overdue') {
        rightActions.push({
          ident: 'like',
          icon: 'thumb',
          tooltip: 'invoice.view.tipMarkPaid',
          tooltipPosition: 'bottomright',
          size: 'big',
          iconSize: '20',
          type: 'success',
          onClick: this._onMarkPaid.bind(this)
        })
      }
    }

    if (invoiceStatus === 'Draft') {
      rightActions.push({
        ident: 'finalize',
        icon: 'done',
        size: 'big',
        iconSize: '20',
        type: isFinalizing ? 'disabled' : 'success',
        label: isQuickbookConnected
          ? 'invoice.view.sendToQuickBooks'
          : 'invoice.view.finalize',
        className: 'finalizebutton',
        onClick: this._onFinalize.bind(this),
        isLoading: isFinalizing
      })

      if (invoice.isRecurring) {
        actions.unshift({
          ident: 'editperiod',
          icon: 'recurring',
          tooltip: 'invoice.view.tipEditPeriod',
          tooltipPosition: 'top',
          onClick: this._onEditPeriod.bind(this)
        })
      }

      actions.unshift({
        ident: 'edit',
        icon: 'edit',
        tooltip: 'invoice.view.tipEditDetails',
        tooltipPosition: 'top',
        onClick: this._onEdit.bind(this)
      })
    }

    if (
      isQuickbookConnected &&
      app.teamCountry === 'US' &&
      invoice.status !== 'Draft'
    ) {
      let titleInfoLabel = 'invoice.view.copyToQuickbook'
      let bSendToQuickbook = true

      if (invoice.quickbook) {
        if (invoice.quickbook.status === 'Completed' && invoice.quickbook.id) {
          bSendToQuickbook = false
          titleInfoLabel = 'invoice.view.copiedToQuickbook'
        } else if (invoice.quickbook.status === 'In-Progress') {
          bSendToQuickbook = false
          titleInfoLabel = 'invoice.view.copingToQuickbook'
        } else if (this.state.bFinalizeInprogress) {
          bSendToQuickbook = false
          titleInfoLabel = 'invoice.view.copingToQuickbook'
        }
      } else if (this.state.bFinalizeInprogress) {
        bSendToQuickbook = false
        titleInfoLabel = 'invoice.view.copingToQuickbook'
      }

      actions.unshift({
        ident: 'quickbook-copy',
        type: 'info',
        title: IntlUtil.convertMessage(titleInfoLabel),
        onClick: bSendToQuickbook ? this._onCopyToQuickbook.bind(this) : null
      })
    }

    // Show title in first of actionbar
    actions.unshift({
      ident: 'status',
      type: 'button',
      title: Util.getTranslatedStatus(invoiceStatus),
      tooltipPosition: 'top',
      className: `headerstatus invoice_${invoiceStatus.toLowerCase()}`
    })

    let mainTitle = invoice.contact ? invoice.contact.company : ''
    if (invoice.isCredit) {
      mainTitle += ` (${IntlUtil.convertMessage(
        'invoice.view.headerLabelCredit'
      )})`
    }

    return (
      <PageHeader
        isTitleMultilingual={false}
        title={mainTitle}
        icon={<InvoicesIcon width={25} />}
        statInfos={statInfos}
        alignStatInfos='bottom'
        actions={actions}
        alignActions='left'
        rightActions={rightActions}
      />
    )
  }

  _onHeaderOpenParentInvoice (invoiceId) {
    app.changePage('invoice-view', invoiceId)
  }

  _onHeaderOpenProject (projectId) {
    app.changePage('projectview-budget', projectId)
  }
  /* Render Header Functions END */
}

export default PageInvoiceView
